import { useState } from "react";

export default function Avatar({ src, name, size = 28, className = "" }) {
  const [errored, setErrored] = useState(false);
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  const sizePx = `${size}px`;

  if (!src || errored) {
    return (
      <div
        className={`rounded-full bg-[#0A84FF] flex items-center justify-center font-bold text-white ${className}`}
        style={{ width: sizePx, height: sizePx, fontSize: `${Math.max(11, size * 0.45)}px` }}
        aria-label={name}
      >
        {initial}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={name}
      onError={() => setErrored(true)}
      className={`rounded-full object-cover ${className}`}
      style={{ width: sizePx, height: sizePx }}
    />
  );
}
